export const HEADERS = ['No', 'Title', 'Market', 'Actions'];
